import React from "react";
import {Button, Typography} from "antd"
import ModalContact from "../../../../modals/ModalContact";
import {CloudOutlined} from "@ant-design/icons";
import {MOBCOLORS, MOBILE_PREFIX_PATH} from "../../../../configs/AppConfig";
import {DynamicIcon} from "lucide-react/dynamic";

const {Text} = Typography

export default class HazkaraDataField extends React.Component {
    render() {

        const {edit, propertie, value, onChange} = this.props

        if (!value.id) {
            return "-"
        }

        if(this.props.mobile)
        {
            return(
                <>
                    <span style={{display:"flex",alignItems:"center",gap:5,textDecorationLine:"underline",cursor:"pointer"}} onClick={()=>{
                        //this.props?.sheetContext?.cancel()
                        //this.props.navigate(MOBILE_PREFIX_PATH+"/contacts/fiche?id="+value.id)
                        this.props?.sheetContext?.openContact(value)
                    }}>
                                            <DynamicIcon name={"contact"} color={MOBCOLORS.blue.color} size={18}/>
                        {value?.nom} {value?.prenom}
                    </span>
                </>
            )
        }

        return (
            <>
                <Button icon={<CloudOutlined/>} type="link"
                        onClick={() => this.modalContact.show(value.id)}>{value.nom} {value.prenom}</Button>

                <ModalContact getRef={(ref) => this.modalContact = ref} onFinish={() => {
                }}/>
            </>
        )
    }
}
